import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import CountryFlag from './CountryFlag';
import './styles.scss';

const Country = ({ code, isShortDetails = false }) => (
    <div className="country">
        <CountryFlag code={code} />
        {!isShortDetails && (
            <Text size="b_xs" color="bodySecondary" paddingLeft="2">
                {translate(`countries.${code}`)}
            </Text>
        )}
    </div>
);

Country.propTypes = {
    code: PropTypes.string.isRequired,
    isShortDetails: PropTypes.bool,
};

export default Country;
